import { useSelector } from 'react-redux'
import { selectUserAccountTypeCheck } from '../../../redux/userSlice'
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner'
import SchoolMobileFallback from './School'
import TeacherMobileFallback from './Teacher'
import { Typography, useMediaQuery, useTheme } from '@mui/material'
import { Navigate } from 'react-router-dom'

const MobileFallback = () => {
    const accountType = useSelector(selectUserAccountTypeCheck)

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

    if (!isMobile) {
        return <Navigate to={'/dashboard'} replace />
    }

    if (accountType === undefined) return <LoadingSpinner />

    switch (accountType) {
        case 'organisation':
        case 'school':
        case 'childcareCentre': {
            return <SchoolMobileFallback />
        }
        case 'teacher': {
            return <TeacherMobileFallback />
        }
        default: {
            return <Typography>Invalid type</Typography>
        }
    }
}

export default MobileFallback
